<code> Ch {{ channelString }} {{ hexvalue }} {{ aiDescription.description.substr(0,20) }} @ {{ aiDescription.department }} </code>


